export const downloadCsv = (csv, fileName) => {
    const link = document.createElement('a');
    const BOM = '\uFEFF';
    link.setAttribute('href', 'data:text/csv;charset=UTF-8,' + encodeURI(BOM + csv));
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
};
export default downloadCsv;
